import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SectionCardProps {
  title?: string;
  description?: string;
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
}

export function SectionCard({
  title,
  description,
  header,
  footer,
  children,
  className,
  headerClassName,
  bodyClassName,
  footerClassName,
}: SectionCardProps) {
  return (
    <div className={cn(
      'surface-elevated rounded-[var(--radius-card)]',
      className
    )}>
      {(title || description || header) && (
        <div className={cn(
          'px-6 py-4 border-b border-border/30 dsos-divider-hairline',
          headerClassName
        )}>
          {header || (
            <>
              {title && (
                <h3 className="text-sm font-semibold text-foreground mb-1">
                  {title}
                </h3>
              )}
              {description && (
                <p className="text-xs text-muted-foreground">
                  {description}
                </p>
              )}
            </>
          )}
        </div>
      )}
      <div className={cn('px-6 py-4', bodyClassName)}>
        {children}
      </div>
      {footer && (
        <div className={cn(
          'px-6 py-4 border-t border-border/30 dsos-divider-hairline',
          footerClassName
        )}>
          {footer}
        </div>
      )}
    </div>
  );
}

